import React from 'react';
import { SectionWrapper } from './SectionWrapper';
const rows = [{
  no: 'Mañana habrá otra crisis',
  yes: 'En 2 horas tienes un plan'
}, {
  no: 'Vas a improvisar otra vez',
  yes: 'La próxima crisis la manejas diferente'
}, {
  no: 'Vas a sentir lo mismo de siempre',
  yes: 'La culpa de las 11 PM desaparece'
}, {
  no: 'El ciclo continúa',
  yes: 'El ciclo se corta'
}];
export function DecisionTable() {
  return <SectionWrapper className="bg-cream py-20" data-id="element-88">
      <h2 className="font-sans text-3xl md:text-4xl font-bold text-ink mb-12 text-center max-w-3xl mx-auto" data-id="element-89">
        Hay dos opciones delante de ti ahora mismo
      </h2>

      <div className="max-w-4xl mx-auto rounded-xl overflow-hidden border border-hairline shadow-soft bg-white" data-id="element-90">
        <div className="grid grid-cols-2" data-id="element-91">
          <div className="bg-cream-dark p-4 md:p-6 text-center border-r border-hairline" data-id="element-92">
            <span className="font-sans font-bold text-ink text-lg" data-id="element-93">
              😔 No haces nada
            </span>
          </div>
          <div className="bg-sage-light p-4 md:p-6 text-center" data-id="element-94">
            <span className="font-sans font-bold text-green-800 text-lg" data-id="element-95">
              ✅ Tomas el protocolo
            </span>
          </div>
        </div>

        <div className="flex flex-col" data-id="element-96">
          {rows.map((row, index) => <div key={index} className="grid grid-cols-2" data-id="element-97">
              <div className="p-4 md:p-6 border-r border-hairline border-t flex items-center justify-center text-center bg-white" data-id="element-98">
                <span className="font-sans text-ink-mid font-medium" data-id="element-99">
                  {row.no}
                </span>
              </div>
              <div className="p-4 md:p-6 border-t border-hairline flex items-center justify-center text-center bg-[#F7FDF9]" data-id="element-100">
                <span className="font-sans text-ink font-medium" data-id="element-101">
                  {row.yes}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </SectionWrapper>;
}